import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { useAuthState, useClient } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'
import { useEffect, useState } from 'react'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { DashboardListCard } from '@app/components/blocks/card/DashboardListCard'
import { INITIATIVE_USER_ROLES } from '@schema/initiative'
import listNotewortyInitiativeFunction from 'functions/app/dashboard/profile/initiative/list-noteworty/based.config'
import { DahsboardListNotewortyInitiativeModel } from 'functions/app/dashboard/profile/initiative/list-noteworty'
import { labelAddressBuilder } from '@app/util/helpers'

export const InitiativesPanel = () => {
  const t = useTranslations()
  const translations = t.app.dashboard
  const client = useClient()
  const authState = useAuthState()
  const [initiatives, setInitiatives] = useState<
    DahsboardListNotewortyInitiativeModel[]
  >([])
  const [_location, navigate] = useLocation()
  const url = listNotewortyInitiativeFunction.name

  useEffect(() => {
    const close = client
      .query(url, {
        top: 5,
        userId: authState.userId,
        role: INITIATIVE_USER_ROLES.follower,
      })
      .subscribe((result) => {
        setInitiatives(result)
      })
    return () => close()
  }, [client, url, authState.userId])

  return (
    <Column
      alignItems="stretch"
      style={{
        backgroundColor: 'var(--palette-white)',
        padding: '1.5rem 1rem',
        borderRadius: '1.25rem',
        flex: '1 1 20rem',
        minWidth: '20rem',
      }}
    >
      <Title.H4 style={{ marginBottom: 0 }}>
        {translations.noteworthyInitiatives}
      </Title.H4>

      {initiatives.map((initiative) => (
        <DashboardListCard
          key={initiative.slug}
          title={initiative.title}
          description={initiative.description}
          image={initiative.images?.[0] ?? defaultProjectPicture}
          location={labelAddressBuilder(
            initiative.location.address,
            t.app.common.notSpecified,
          )}
          status={initiative.phase?.name}
          onClick={() => navigate(pages.initiative(initiative.slug))}
        />
      ))}
    </Column>
  )
}
